import { Sparkles, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useCatalystFlow } from '@/contexts/CatalystFlowContext';
import { useUserPlan } from '@/hooks/useUserPlan';
import { useState } from 'react';
import { PlanComparisonModal } from '@/components/PlanComparisonModal';

export function AskCatalystFlowButton() {
  const { setIsOpen } = useCatalystFlow();
  const { currentPlan, loading } = useUserPlan();
  const [showUpgrade, setShowUpgrade] = useState(false);

  const isPro = currentPlan?.planType?.toLowerCase() === 'pro_ai' || 
                currentPlan?.planType?.toLowerCase() === 'pro';

  const handleClick = () => {
    if (isPro) {
      setIsOpen(true);
    } else {
      setShowUpgrade(true);
    }
  };

  if (loading) {
    return (
      <Button variant="ghost" size="sm" disabled className="opacity-50">
        <Sparkles className="h-4 w-4 mr-1.5" />
        <span className="hidden md:inline">Ask Catalyst Flow</span>
      </Button>
    );
  }

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={isPro ? "ghost" : "ghost"}
            size="sm"
            onClick={handleClick}
            className={`gap-1.5 transition-all ${
              isPro 
                ? 'text-primary hover:text-primary hover:bg-primary/10' 
                : 'opacity-60 hover:opacity-80'
            }`}
          >
            {isPro ? (
              <Sparkles className="h-4 w-4" />
            ) : (
              <Lock className="h-4 w-4" />
            )}
            <span className="hidden md:inline">Ask Catalyst Flow</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          {isPro 
            ? "Your AI Co-Founder - Ask anything about your business" 
            : "Available in PRO — Your AI Co-Founder"}
        </TooltipContent>
      </Tooltip>

      <PlanComparisonModal
        open={showUpgrade}
        onOpenChange={setShowUpgrade}
        currentPlanType={currentPlan?.planType}
      />
    </>
  );
}
